export default "__VITE_ASSET__Npl5Qboc__"